import { useRouter } from 'next/router'

export function useActivePage() {
	//@TODO reconstruct from querry param
	return useRouter().asPath
}
